import React from "react";
import Box from "@mui/material/Box";
import ButtonBase from "@mui/material/ButtonBase";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { text } from "./modalStyles";

// ButtonBase rather than Button: the theme pills every MuiButton at
// borderRadius 50, which looks wrong on a full-width card.
const styles = {
  card: selected => ({
    width: "100%",
    p: 2,
    borderRadius: 1,
    border: "1px solid",
    borderColor: selected ? "primary.main" : "divider",
    bgcolor: selected ? "action.selected" : "background.paper",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 1.5,
    textAlign: "left",
    transition: "border-color 120ms ease, background-color 120ms ease",
    "&:hover": { borderColor: "primary.main", bgcolor: "action.hover" },
  }),
  chevron: { color: "text.disabled", fontSize: 20, flexShrink: 0 },
};

export default function OptionCard({ label, description, selected = false, onClick }) {
  return (
    <ButtonBase onClick={onClick} sx={styles.card(selected)}>
      <Box>
        <Typography sx={text.optionLabel}>{label}</Typography>
        {description && (
          <Typography sx={{ ...text.optionHelp, mt: 0.25 }}>{description}</Typography>
        )}
      </Box>
      <ChevronRightIcon sx={styles.chevron} />
    </ButtonBase>
  );
}
